import React from "react"

function ArrowUp(props) {
  return (
    <svg width={27} height={27} fill="none" {...props}>
      <path
        d="M25.111 13.304L13.556 2 2 13.304m11.556 11.305V2"
        stroke={ `${ props.color || "#4B3866" }` }
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default ArrowUp
